import { motion } from "framer-motion";
import { VESSELS } from "@/data/temple";
import { Eyebrow, Reveal } from "./Reveal";

const Card = ({ v, i }) => (
  <motion.article
    data-testid={`vessel-card-${v.id}`}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay: (i % 4) * 0.08 }}
    whileHover={{ y: -6 }}
    className={`group relative overflow-hidden rounded-[2px] border border-[#D9B47A]/15 bg-[#120C0A] p-7 min-h-[260px] flex flex-col justify-end ${v.span}`}
  >
    {v.img && (
      <>
        <img src={v.img} alt="" className="absolute inset-0 w-full h-full object-cover opacity-55 transition-transform duration-[1.6s] group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0706] via-[#0A0706]/70 to-transparent" />
      </>
    )}
    <span className="absolute top-6 right-7 font-tt-mono text-[12px] text-[#D9B47A]">{String(i + 1).padStart(2, "0")}</span>
    <div className="relative">
      <h3 className="font-display text-2xl sm:text-3xl">{v.name}</h3>
      <p className="mt-3 text-[15px] text-[#CFC2B6] leading-relaxed max-w-md">{v.text}</p>
    </div>
    <span className="absolute left-0 bottom-0 h-px w-full bg-[#C2414F] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-700" />
  </motion.article>
);

export default function Vessels() {
  return (
    <section id="vessels" data-testid="vessels-section" className="relative bg-[#0D0908] border-y border-[#D9B47A]/10">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10 py-28 sm:py-40">
        <Reveal className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div>
            <Eyebrow n="IV">The Vessels of Pleasure</Eyebrow>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-8 max-w-3xl leading-[1.05]">
              Pleasure is not something you chase. It is something you <em className="text-[#D9B47A]">conduct.</em>
            </h2>
          </div>
          <p className="max-w-sm text-[#A8998C]">
            Some vessels spark. Some spread. Some ground. Some soften. Awakened together, they become a living symphony.
          </p>
        </Reveal>
        <div data-testid="vessels-bento" className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {VESSELS.map((v, i) => <Card key={v.id} v={v} i={i} />)}
        </div>
      </div>
    </section>
  );
}
